import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';
import * as bootstrap from 'bootstrap';

export default class InvestFormController extends Controller {
  static targets = [
    'subscriptionAmount',
    'feesAmount',
    'fieldsErrors',
    'subscriptionAmountDivs',
    'feesAmountDivs',
    'totalAmountDivs',
    'modalTotal',
    'submitButton',
    'insufficientBalance',
    'subscribeModal',
    'provisionalBalance',
  ];

  static values = {
    projectId: String,
    profileBalance: Number,
    max_invest_recommendation: Number,
    user_may_have_warning: Boolean,
  };

  // Compute fees and total through backend
  computeFeesAndTotal() {
    const amount = this.subscriptionAmountTarget.value;
    let controller = this;
    const profileBalance = parseFloat(this.profileBalanceValue);

    // Check if the amount is valid
    controller.checkAmountValidity(amount);

    // Display amount
    controller.modalTotalTarget.innerHTML =
      Helpers.numberToCurrency(amount, 2);

    controller.provisionalBalanceTarget.innerHTML =
      Helpers.numberToCurrency(profileBalance - amount, 2);
  }

  checkAmountValidity(amount) {
    this.insufficientBalanceTarget.classList.add('d-none');

    const profileBalance = parseFloat(this.profileBalanceValue);

    switch (true) {
      case !this.subscriptionAmountTarget.checkValidity():
        this.fieldsErrorsTarget.innerHTML =
          this.subscriptionAmountTarget.validationMessage;
        return this.triggerError();
      case amount === '':

        this.fieldsErrorsTarget.innerHTML =
          'Un montant de souscription doit être renseigné.';
        return this.triggerError();
      case amount > profileBalance:
        this.insufficientBalanceTarget.classList.remove('d-none');
        this.fieldsErrorsTarget.innerHTML = '';
        return this.triggerError();
      default:
        this.submitButtonTarget.classList.remove('disabled');
        this.fieldsErrorsTarget.innerHTML = '';
        this.subscriptionAmountTarget.classList.remove('is-invalid');
        return true;
    }
  }

  updateAmounts(container, amount) {
    const finalAmount =
      amount === 0 || isNaN(amount)
        ? 'CHF-,--'
        : Helpers.numberToCurrency(amount, 2);

    container.forEach((element) => {
      element.innerHTML = finalAmount;
    });
  }

  triggerError() {
    this.submitButtonTarget.classList.add('disabled');
    this.subscriptionAmountTarget.classList.add('is-invalid');
    return false;
  }

  validateAndShowSubscriptionModal() {
    const amount = this.subscriptionAmountTarget.value;
    const maxInvestRecommendation = this.maxInvestRecommendationValue;

    if (!this.checkAmountValidity(amount)) return;

    this.showModal(this.subscribeModalTarget);
  }

  preventAutoSubmit(event) {
    event.preventDefault();
    this.validateAndShowSubscriptionModal();
  }

  showModal(modalTarget) {
    const modal = new bootstrap.Modal(modalTarget);
    modal.show();
  }
}
